// src/pages/Home/data/heroApplications.js

const heroApplications = [
  {
    id: "club",
    prefix: "MonAppli",
    suffix: "Club",
    color: "#ff7900",
    logo: "/images/logo/logo_monappliclub2026_512.png",
  },
  {
    id: "mairie",
    prefix: "MonAppli",
    suffix: "Mairie",
    color: "#1677ff",
    logo: "/images/logo/logo-monapplimairie.webp",
  },
  {
    id: "tournoi",
    prefix: "MonAppli",
    suffix: "Tournoi",
    color: "#fe7d00",
    logo: "/images/logo/logo_monapplitournoi_512.png",
  },
  {
    id: "asso",
    prefix: "MonAppli",
    suffix: "Asso",
    color: "#0b6faf",
    logo: "/images/logo/logo_monappliasso_512.png",
  },
  {
    id: "ag",
    prefix: "MonAppli",
    suffix: "AG",
    color: "#0aa676",
    logo: "/images/logo/logo_monappliag_2026.png",
  },
  {
    id: "comite",
    prefix: "MonAppli",
    suffix: "Comité",
    color: "#ff7900",
    logo: "/images/logo/logo_monappliclub2026_512.png",
  },
  {
    id: "ligue",
    prefix: "MonAppli",
    suffix: "Ligue",
    color: "#ff7900",
    logo: "/images/logo/logo_monappliclub2026_512.png",
  },
  {
    id: "event",
    prefix: "MonAppli",
    suffix: "Event",
    color: "#ff7900",
    logo: "/images/logo/logo_monappliclub2026_512.png",
  },
];

export default heroApplications;